import { Permission } from "@/api/dtos";
import QueryTable from "@/components/tables/QueryTable";
import { allStates } from "@/constants/AllStates";
import { Box, Paper, styled } from "@mui/material";
import { InstitutionBreadcrumbs, InstitutionContext, PageLayout, PatientsByCodesProvider } from "@ngt/opms";
import { usePermissionsByIds } from "@ngt/opms-bctapi";
import { FC, useContext, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";


const StyledContainer = styled(Paper)(({theme}) => ({
    padding: theme.spacing(3)
}));

const StyledTableContainer = styled(Box)(({theme}) => ({
    padding: theme.spacing(4, 0, 0, 0)
}));

interface IQueriesPageProps {

}
const 
pageSizeOptions = [5, 10, 20, 50, 100];

const QueriesPage: FC<IQueriesPageProps> = ({

}) => {
    const navigate = useNavigate();

    const { data: institution } = useContext(InstitutionContext);
    
    const {
        permissions: [
            canOpmsAdmin,
            canOpmsDataManage,
            canViewQuerySummaries
        ],
        loading: permissionsLoading
    } = usePermissionsByIds(
        [
            Permission.OpmsAdminister, // BCT staff + CRA/CSM
            Permission.OpmsDataManage,
            Permission.CanViewQuerySummaries
        ], 
        undefined, 
        undefined, 
        institution?.id
    );
    
    const canAdministerOpms = useMemo(() => {
        return canOpmsAdmin || canOpmsDataManage;
    }, [canOpmsAdmin, canOpmsDataManage]);

    useEffect(() => {
        if (!permissionsLoading) {
            if (!canViewQuerySummaries && !canAdministerOpms) {
                navigate(`/registration`, {replace: true});
            }
        }
    }, [canViewQuerySummaries, canAdministerOpms, permissionsLoading, navigate]);
    
    return (
        <PageLayout
            breadcrumbs={<InstitutionBreadcrumbs />}
            heading='Queries'
        >
            <PatientsByCodesProvider
                patientStateIds={allStates}
            >
                <StyledContainer>
                    <StyledTableContainer>
                        <Box
                            sx={{
                                mt: 2
                            }}
                        >
                            <QueryTable 
                                title='Queries'
                                disableColumnMenu={false}
                                pageSizeOptions={pageSizeOptions}
                            />
                        </Box>
                    </StyledTableContainer>
                </StyledContainer>
            </PatientsByCodesProvider>
        </PageLayout>
    );
}

export default QueriesPage;